import React from "react"
import { GatsbyImage } from "gatsby-plugin-image";
import ContainerMax from "components/shared/ContainerMax"
import styled, { css } from "styled-components"
import { media } from "utils/Media"

const ContainerMaxStyled = styled(ContainerMax)`
  display: block;
  position: relative;
  overflow: hidden;

  ${props => props.$overlay && css`
    &:after {
      content: "";
      position: absolute;
      z-index: 2;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
      background-image: linear-gradient(to right, rgba(50,55,65, .65), rgba(50,55,65, 0));
      display:none;
      
      @media ${media.md} {
        display:block;
      }
    }
  `}
`

const TitleStrip = styled.div`
  background-color: ${props => props.theme.colors.primary};
  padding: 1rem;
  h1 {
    color: white;
    text-align: center;
    margin: 0;
    padding: 0;
  }
`

const Hero = (props) => {
  const {
    overlayTint,
    imageMobile,
    imageDesktop,
    title
  } = props.block
  return (
    <ContainerMaxStyled maxWidth="1920" noPadding $overlay={overlayTint}>
      {imageMobile !== null &&
        <GatsbyImage
          image={imageMobile.localFile.childImageSharp.gatsbyImageData}
          className="d-sm-none"
          alt={imageMobile.altText} 
          />    
      }
      {imageDesktop !== null &&
        <GatsbyImage
          image={imageDesktop.localFile.childImageSharp.gatsbyImageData}
          className="d-none d-sm-block"
          alt={imageDesktop.altText} 
        />    
      }
      {title && (
        <TitleStrip>
          <h1>{title}</h1>
        </TitleStrip>
      )}
    </ContainerMaxStyled>
  )
}

export default Hero